const urls = {
    OLD_URL: `https://dev.janitri.in/`,
    BETA_URL: `https://beta.janitri.in/`,
    S3_URL: `https://beta.janitri.in/statics/`,
    LOCAL_URL: `http://localhost:8000/`,
    DEV_URL: `https://jfh.dev.janitri.in/`
    // BETA_URL:`http://35.168.153.227:8000/`
}

export default urls;